import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../store'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const RemnantRegist = () => import('@/views/RemnantRegist')
const RemnantPastInfo = () => import('@/views/RemnantPastRecord')
const DonateRegist = () => import('@/views/DonateRegist')
const ApplyRegist = () => import('@/views/ApplyRegist')

// admin
const DonateList = () => import('@/views/DonateList')
const ApplyList = () => import('@/views/ApplyList')
const ApplyPrint = () => import('@/views/ApplyPrint')
const RemnantList = () => import('@/views/RemnantList')
const FinalList = () => import('@/views/FinalList')
const OMCList = () => import('@/views/OmcUpload')
const AdminControl = () => import('@/views/admin/AdminControl')
const AdminLog = () => import('@/views/admin/AdminLog')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Login = () => import('@/views/pages/Login')
const Page500 = () => import('@/views/pages/Page500')

// Views - Pages
const Interview = () => import('@/views/document/Interview')

Vue.use(Router)

var auth = (to, from, next) => {
  /* 회원가입을 위한 예외처리 */
  if (from.name === 'Login' && to.name === 'MyInfo') {
    return next()
  }
  /*
  let retok = store.state.REFRESH_TOKEN
  let email = store.state.EMAIL
  if (retok === '' || email === '') {
    alert('로그인이 필요합니다 (You need to sign in)')
    return next('/pages/login?returnPath=' + to.name)
  }
   */
  let headers = { 'Authorization': 'Bearer ' + store.state.REFRESH_TOKEN }
  axios.post(store.state.APISERVER + '/refresh', {}, { headers: headers })
    .then(response => {
      let data = response.data
      store.commit('setToken', data.token)
      return next()
    })
    .catch(error => {
      store.commit('resetToken')
      console.log('token expired', error)
      return next('/pages/login?returnPath=' + to.name)
    })
}

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/apply/print',
      name: 'ApplyPrint',
      component: ApplyPrint
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/remnant',
          redirect: '/remnant/regist',
          name: 'Remnant',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'regist',
              name: 'MyInfo',
              beforeEnter: auth,
              component: RemnantRegist
            },
            {
              path: 'pastinfo',
              name: 'PastInfo',
              beforeEnter: auth,
              component: RemnantPastInfo
            }
          ]
        },
        {
          path: '/apply',
          redirect: '/apply/regist',
          name: 'Apply',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: auth,
          children: [
            {
              path: 'regist',
              name: 'ApplyRegist',
              component: ApplyRegist
            }
          ]
        },
        {
          path: '/donate',
          redirect: '/donate/regist',
          name: 'Donate',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'regist',
              name: 'DonateRegist',
              component: DonateRegist
            }
          ]
        },
        {
          path: '/part',
          name: 'Part',
          redirect: '/part/list',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: auth,
          children: [
            {
              path: 'list',
              name: 'PartList',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'apply',
                  name: 'ApplyList',
                  component: ApplyList
                }
              ]
            },
            {
              path: 'logs',
              name: 'PartLog',
              component: AdminLog
            }
          ]
        },
        {
          path: '/admin',
          name: 'Admin',
          redirect: '/admin/list',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: auth,
          children: [
            {
              path: 'control',
              name: 'AdminContol',
              component: AdminControl
            },
            {
              path: 'logs',
              name: 'AdminLog',
              component: AdminLog
            },
            {
              path: 'list',
              name: 'AdminList',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'donate',
                  name: 'DonateList',
                  component: DonateList
                },
                {
                  path: 'remnant',
                  name: 'RemnantList',
                  component: RemnantList
                },
                {
                  path: 'final',
                  name: 'FinalList',
                  component: FinalList
                },
                {
                  path: 'omc',
                  name: 'OMClList',
                  component: OMCList
                }
              ]
            }
          ]
        },
        {
          path: '/document',
          redirect: '/document/interview',
          name: 'Document',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'interview',
              name: 'Interview',
              component: Interview
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    }
  ]
})
